import { render, staticRenderFns } from "./KvmOwnDomain.vue?vue&type=template&id=fbd6ba1e&scoped=true&"
import script from "./KvmOwnDomain.vue?vue&type=script&lang=js&"
export * from "./KvmOwnDomain.vue?vue&type=script&lang=js&"
import style0 from "./KvmOwnDomain.vue?vue&type=style&index=0&id=fbd6ba1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd6ba1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbd6ba1e')) {
      api.createRecord('fbd6ba1e', component.options)
    } else {
      api.reload('fbd6ba1e', component.options)
    }
    module.hot.accept("./KvmOwnDomain.vue?vue&type=template&id=fbd6ba1e&scoped=true&", function () {
      api.rerender('fbd6ba1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmOwnDomain.vue"
export default component.exports